/**
 * Service for position creation operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import {
  mapCreatePositionFromTransport,
  mapCreatePositionToTransport,
} from '../mappers';
import type {
  CreatePositionRequest,
  CreatePositionResult,
  LC_CreatePositionOut,
} from '../types';


export class PositionCreateService {
  async create(
    request: CreatePositionRequest,
  ): Promise<ApiResponse<CreatePositionResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.POSITIONS;
    const payload = mapCreatePositionToTransport(request);

    const response = await apiClient.post<LC_CreatePositionOut>(endpoint, payload);

    if (response.success && response.data) {
      return {
        ...response,
        data: mapCreatePositionFromTransport(response.data),
      };
    }

    return { ...response, data: null };
  }
}

export const positionCreate = new PositionCreateService();